class PrDiag {
    constructor(el, options = {}){ 

        this.diag = el;
        this.stepCurrent = 0;
        this.diagData = {}; 
        this.diagPunchline = {};

        this.countStep = document.querySelectorAll(".content-diag-step").length; 

        this.options = Object.assign(
            {},
            {  
                mode: "guest", 
                dev: false, 
                catalog: ""
            }, 
            options
        );    
        document.querySelectorAll(".goto").forEach(goto => {
            goto.addEventListener("click", () => { 
                let index = parseInt(goto.getAttribute("data-goto"));
                this.goToStep(index);
            });
        }); 

        if(this.options.dev){
            this.diagData = {
                "peau": [
                    "serum-booster-eclat-a-la-vitamine-c-gamme-vitamin-c",
                    "creme-anti-age-lift-intense-aux-peptides-gamme-global",
                    "masque-gel-acide-hyaluronique-gamme-hyaluronic",
                    "creme-anti-age-lift-intense-aux-peptides-gamme-global",
                    "masque-bio-cellulose-a-lextrait-de-myrtille-gamme-global"
                ],
                "yeux": [
                    "serum-booster-eclat-a-la-vitamine-c-gamme-vitamin-c",
                    "creme-anti-age-lift-intense-aux-peptides-gamme-global"
                ],
                "nettoyants": [
                    "eau-micellaire-gamme-essentials",
                    "lotion-tonique-a-lextrait-de-coton-gamme-essentials",
                    "gommage-creme-aux-grains-de-bambou-gamme-pure"
                ],
                "pollution": [
                    "masque-bio-cellulose-oxygenant-gamme-detox",
                    "masque-detox-au-charbon-gamme-detox",
                    "serum-booster-eclat-a-la-vitamine-c-gamme-vitamin-c",
                    "creme-anti-age-lift-intense-aux-peptides-gamme-global"
                ]
            };

            this.diagPunchline = { 
                "peau": [
                    "La détoxifier, lui redonner un coup de boost et réveiller mon teint terne&nbsp;!",
                    "Lui redonner toute la douceur et le glow qu'elle mérite&nbsp;!",
                    "Des rides estompées et une peau plus ferme&nbsp;!"
                ],
                "yeux": [
                    "Redonner confort à mon contour des yeux"
                ],
                "nettoyants": [],
                "pollution": [] 
            }
        } 

        if(header.querySelector("#btn-cart") != null){
            header.querySelector("#btn-cart").addEventListener("click", () => {
                cart.openCart();
            });
        }

        /*
        if(this.options.customer.prenom != ""){
            this.diag.querySelector("input[name='prenom']").value = this.options.customer.prenom;
        }

        if(this.options.customer.email != ""){
            this.diag.querySelectorAll("input[name='email']").forEach(iName => {
                iName.value = this.options.customer.email;
            });
        }*/

        console.log(this.options.catalog);

        document.addEventListener('keyup', (e) => {
            if(e.code == "Enter" && document.querySelectorAll(".content-diag-step")[this.stepCurrent].querySelector(".btn-confirm") != null){
                document.querySelectorAll(".content-diag-step")[this.stepCurrent].querySelector(".btn-confirm").click();
            } 
        });  

        //Events 
        document.querySelectorAll(".content-diag-step").forEach((cstep, index) => { 
            cstep.setAttribute("data-index", index); 
            let mode = cstep.getAttribute("data-mode");  
            let cat = cstep.getAttribute("data-cat");   
            if(typeof cat != "undefined" && cat != null && typeof this.diagData[cat] == "undefined"){
                this.diagData[cat] = [];
            } 
            if(typeof cat != "undefined" && cat != null && typeof this.diagPunchline[cat] == "undefined"){
                this.diagPunchline[cat] = [];
            } 
            if(cstep.querySelector(".back")){
                cstep.querySelector(".back").addEventListener("click", () => {
                    let lastIndex = this.stepCurrent-1;
                    if(lastIndex != 0){
                        if(lastIndex == 1){ 
                            document.querySelectorAll(".content-diag-step")[lastIndex + 1].querySelectorAll(".choix.off").forEach(c => { 
                                c.classList.remove("off"); 
                            }); 
                        }
                        document.querySelectorAll(`.content-diag-step[data-index="${this.stepCurrent}"] .choix.active`).forEach(c => {
                            c.classList.remove("active"); 
                        });
                        document.querySelectorAll(`.content-diag-step[data-index="${lastIndex}"] .choix.active`).forEach(c => {
                            let cat = c.closest(".content-diag-step").getAttribute("data-cat"); 
                            if(c.getAttribute("data-prd") != ""){
                                this.diagData[cat].pop(c.getAttribute("data-prd")); 
                            }
                            if(c.getAttribute("data-prd2") != ""){
                                this.diagData[cat].pop(c.getAttribute("data-prd2")); 
                            }
                            if(c.getAttribute("data-punchline") != ""){
                                this.diagPunchline[cat].pop(c.getAttribute("data-punchline")); 
                            }  
                            c.classList.remove("active");
                        });
                    } 
                    this.goToStep(lastIndex); 
                });
            }
            cstep.querySelectorAll(".choix").forEach(a => {  
                a.addEventListener("click", () => {   
                    if(mode == "solo"){ 
                        console.log("solo");   
                        if(a.getAttribute("data-prd") != ""){
                            this.diagData[cat].push(a.getAttribute("data-prd")); 
                        }
                        if(a.getAttribute("data-prd2") != ""){
                            this.diagData[cat].push(a.getAttribute("data-prd2")); 
                        }
                        if(a.getAttribute("data-punchline") != ""){
                            this.diagPunchline[cat].push(a.getAttribute("data-punchline")); 
                        } 
                        a.classList.add("active");
                        if(index == 1){
                            let label = a.innerHTML;
                            document.querySelectorAll(".content-diag-step")[this.stepCurrent + 1].querySelectorAll(".choix").forEach(c => {
                                if(c.innerHTML == label){
                                    c.classList.add("off");
                                }
                            }); 
                        }
                        setTimeout(() => {
                            this.goToStep(this.stepCurrent + 1);
                        }, 200);
                    }else{  
                        let countActive = cstep.querySelectorAll(".choix.active").length; 
                        console.log(countActive);
                        if(a.classList.contains("active")){
                            a.classList.remove("active");
                        }else{
                            if(countActive < 2){
                                a.classList.add("active");
                            }else{
                                this.showError("2 choix maximum", 3500);
                            }
                        }   
                    } 
                }); 
            });

            if(mode == "multiple"){
                cstep.querySelector(".btn-confirm").addEventListener("click", () => { 
                    if(cstep.querySelectorAll(".choix.active").length > 0){   
                        cstep.querySelectorAll(".choix.active").forEach(c => {
                            if(c.getAttribute("data-prd") != ""){
                                this.diagData[cat].push(c.getAttribute("data-prd")); 
                            }
                            if(c.getAttribute("data-prd2") != ""){
                                this.diagData[cat].push(c.getAttribute("data-prd2")); 
                            }
                            if(c.getAttribute("data-punchline") != ""){
                                this.diagPunchline[cat].push(c.getAttribute("data-punchline")); 
                            }
                        }); 
                        this.goToStep(this.stepCurrent+1);
                        this.killError();
                    }else{
                        this.showError("Vous devez séléctionner au moins un champs.", 2000);
                    }
                });
            }  
        });

        this.diag.querySelector(".btn-resultat").addEventListener("click", ()=>{ 
            this.validForm(); 
        });

        //Init 
        this.goToStep(0);
        if(this.options.dev){
            this.buildResult({
                "prenom": "régis",
                "anniversaire": "2222-02-22",
                "type": "homme",
                "email": "schmitz.regis@gmail.com"
            });
        }

        if(this.getParams("mode") != null && this.getParams("mode") == "resultat"){

            if(this.getParams("cat_peau") != null){ 
                if(typeof this.diagData["peau"] == "undefined"){
                    this.diagData["peau"] = [];
                }   
                this.diagData["peau"] = this.getParams("cat_peau").split(",")
            }
            if(this.getParams("cat_yeux") != null){ 
                if(typeof this.diagData["yeux"] == "undefined"){
                    this.diagData["yeux"] = [];
                }   
                this.diagData["yeux"] = this.getParams("cat_yeux").split(",")
            }
            if(this.getParams("cat_nettoyants") != null){ 
                if(typeof this.diagData["nettoyants"] == "undefined"){
                    this.diagData["nettoyants"] = [];
                }   
                this.diagData["nettoyants"] = this.getParams("cat_nettoyants").split(",")
            }
            if(this.getParams("cat_pollution") != null){ 
                if(typeof this.diagData["pollution"] == "undefined"){
                    this.diagData["pollution"] = [];
                }   
                this.diagData["pollution"] = this.getParams("cat_pollution").split(",")
            } 

            if(this.getParams("punch_peau") != null){ 
                if(typeof this.diagPunchline["peau"] == "undefined"){
                    this.diagPunchline["peau"] = [];
                }   
                this.diagPunchline["peau"] = this.getParams("punch_peau").split(",")
            }
            if(this.getParams("punch_yeux") != null){ 
                if(typeof this.diagPunchline["yeux"] == "undefined"){
                    this.diagPunchline["yeux"] = [];
                }   
                this.diagPunchline["yeux"] = this.getParams("punch_yeux").split(",")
            }
            if(this.getParams("punch_nettoyants") != null){ 
                if(typeof this.diagPunchline["nettoyants"] == "undefined"){
                    this.diagPunchline["nettoyants"] = [];
                }   
                this.diagPunchline["nettoyants"] = this.getParams("punch_nettoyants").split(",")
            }
            if(this.getParams("punch_pollution") != null){ 
                if(typeof this.diagData["pollution"] == "undefined"){
                    this.diagPunchline["pollution"] = [];
                }   
                this.diagPunchline["pollution"] = this.getParams("punch_pollution").split(",")
            } 


            document.querySelector(".infos_mail").style.display = "none";
            this.buildResult({
                "prenom": this.getParams("prenom"), 
                "anniversaire": this.getParams("anniversaire"),
                "type": this.getParams("type"),
                "email": this.getParams("email")
            }, true); 
        }
        
    }  

    getParams(parameterName) {
        var result = null,
            tmp = [];
        location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (decodeURIComponent(tmp[0]) === parameterName) result = decodeURIComponent(tmp[1]);
        });
        return result;
    }

    validationEmpty(value){
        if(value.length > 1){
            return true;
        }else{
            return false; 
        }
    }

    validationEmail(email){
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.match(validRegex)) {
            return true;
        }else{
            return false;
        }
    } 

    validForm(){
        document.querySelector(".content-diag-final").classList.add("loading");
        let error = 0;
        let messagesError = [];
        let form = document.querySelector(".diag-final .form");
        let prenom = this.validationEmpty(form.querySelector("[name='prenom']").value);
        let anniversaire = this.validationEmpty(form.querySelector("[name='anniversaire']").value);
        let type = this.validationEmpty(form.querySelector("[name='type']").value);
        let email = this.validationEmail(form.querySelector("[name='email']").value);

        if(!prenom){
            error++;
            messagesError.push("Champs 'Prénom' vide.");
        }

        if(!anniversaire){
            error++;
            messagesError.push("Champs 'Anniversaire' vide.");
        }

        if(!type){
            error++;
            messagesError.push("Champs 'Type' vide.");
        }

        if(!email){
            error++;
            messagesError.push("Email invalide.");
        }

        if(error == 0){
            this.killError();
            this.result();
        }else{ 
            document.querySelector(".content-diag-final").classList.remove("loading");
            this.showFormError(messagesError, 2000);
        }
    }

    updateScrollbar(contentScrollbar, target) {
        const content = target.querySelector(".content-scrollable");
        const contentScrollHeight = content.scrollHeight;
        const contentHeight = content.clientHeight;
        const scrollRatio = contentHeight / contentScrollHeight;
        const thumbHeight = (contentHeight * scrollRatio);
        const thumbPosition = content.scrollTop * scrollRatio;

        contentScrollbar.querySelector(".cursor").style.height = `${thumbHeight}px`;
        contentScrollbar.querySelector(".cursor").style.top = `${thumbPosition}px`;
    }

    buildScrollbar(target){  
        let contentScrollbar = this.createElementWithClass("div", "content-scrollbar");
        let lineScrollbar = this.createElementWithClass("div", "line-scrollbar");
        let cursor = this.createElementWithClass("div", "cursor");
        contentScrollbar.appendChild(cursor);
        contentScrollbar.appendChild(lineScrollbar);
        target.appendChild(contentScrollbar); 
        this.updateScrollbar(contentScrollbar, target); 
        target.querySelector(".content-scrollable").addEventListener('scroll', () => {
            this.updateScrollbar(contentScrollbar, target); 
        });
    }

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    killError(){
        var errors = document.querySelectorAll(".content-error");
        if(errors.length > 0){
            errors.forEach(e => {
                e.remove();
            })
        }
    }

    showFormError(messages, time){
        this.killError();
        var contentError = document.createElement("div");
        contentError.classList.add("content-error");
        var error = document.createElement("div");
        error.classList.add("error");
        let listError = this.createElementWithClass("ul", "list");
        messages.forEach(m => {
            let error = this.createElementWithClass("li", "error-text");
            error.innerHTML = m;
            listError.appendChild(error);
        })
        error.appendChild(listError);
        contentError.appendChild(error);
        document.querySelector("body").appendChild(contentError);
        setTimeout(() => {
            contentError.classList.add("show");
        },100); 
        setTimeout(() => {
            contentError.remove();
        }, time);
    }

    showError(message, time){
        this.killError();
        var contentError = document.createElement("div");
        contentError.classList.add("content-error");
        var error = document.createElement("div");
        error.classList.add("error");
        error.innerHTML = message;
        contentError.appendChild(error);
        document.querySelector("body").appendChild(contentError);
        setTimeout(() => {
            contentError.classList.add("show");
        },100); 
        setTimeout(() => {
            contentError.remove();
        }, time);
    }

    checkForName(name){
        document.querySelectorAll(".content-diag-step .step .content-desc .desc h2").forEach(desc => {
            var texte = desc.textContent;  
            var newTexte = texte.replace("[Prénom]", name);  
            desc.textContent = newTexte; 
        }); 
    } 

    updateProgressBar(index){ 
        let max = this.countStep - 1;
        let percent = Math.round(index * 100 / max);
        document.querySelector(".content-progress .progress").style.width = `${percent}%`;
        document.querySelector(".content-progress .progress .percent").innerHTML = `${percent}%`;
    }

    goToStep(index){  
        if(index > 0 && index < this.countStep - 1){
            if(!document.querySelector(".content-progress").classList.contains("show")){
                document.querySelector(".content-progress").classList.add("show");
            }
            this.updateProgressBar(index);
        }else{
            if(document.querySelector(".content-progress").classList.contains("show")){
                document.querySelector(".content-progress").classList.remove("show");
            }
        }
        if(document.querySelectorAll(".content-diag-step")[index].classList.contains("scrollable")){
            this.buildScrollbar(document.querySelectorAll(".content-diag-step")[index]);
        }   
        this.stepCurrent = index;   
        document.querySelectorAll(".content-diag-step")[index].classList.remove("off"); 
        document.querySelectorAll(".content-diag-step")[index].querySelectorAll(".choix").forEach(choix => {
            setTimeout(()=> {
                choix.classList.add("loaded");
            }, 300);
        }); 
        let toScroll = document.querySelectorAll(".content-diag-step")[index].offsetTop;  
        this.diag.querySelector("#diag").style.transform = `translateY(-${toScroll}px)`; 
    }
 
    addZero (number){
        if (number < 10) {
            number = "0" + number;
        }
        return number;
    } 

    getTime(date){
        return this.addZero(parseInt(date.getHours())) + ":" + this.addZero(parseInt(date.getMinutes())) + ":" + this.addZero(parseInt(date.getSeconds()));
    }

    removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
    }  

    result(){     
        console.log("final");
        let infos = {};
        this.diag.querySelectorAll(".diag-final [name]").forEach(field => {
            infos[field.getAttribute("name")] = field.value; 
        });
        console.log(infos);  
        this.track(infos.email, infos); 
    }

    buildResult(infos, fast = false){  
        document.querySelector(".content-progress").classList.add("hide");
        let toScroll = document.querySelector(".content-resultat-diag").offsetTop;  
        this.diag.querySelector("#diag").style.transform = `translateY(-${toScroll}px)`; 
        if(fast){
            this.diag.querySelector("#diag").style.transition = `none`; 
        }
        this.diag.querySelector(".content-resultat-diag .name").innerHTML = infos.prenom;
 
        //console.log(this.diagData);
        if(this.diagData["yeux"].length != 0){
            this.diagData["yeux"].forEach(prd => {
                this.diagData["peau"].push(prd);
            });
        }
        //console.log("peau", this.diagData["peau"]);
        Object.entries(this.diagData).forEach(cat => {
            if(cat[1].length > 0 && cat[0] != "yeux"){ 
                this.buildProducts(cat[1], this.diag.querySelector(`.content-resultat-diag .products[data-cat="${cat[0]}"]`));
            }else{
                if(this.diag.querySelector(`.content-resultat-diag .products[data-cat="${cat[0]}"]`)){
                    this.diag.querySelector(`.content-resultat-diag .products[data-cat="${cat[0]}"]`).closest(".content-products").classList.add("off");
                }
            }
        });

        Object.entries(this.diagPunchline).forEach(cat => { 
            if(cat[1].length > 0){
                cat[1].forEach(preo => {
                    let preoH = this.createElementWithClass("li", "preo");
                    let content = this.createElementWithClass("div", "content");
                    const regex = /\+/g;
                    let preoC = preo.replace(regex, " ");
                    content.innerHTML = preoC; 
                    preoH.appendChild(content);  
                    this.diag.querySelector(`.content-resultat-diag .content-recap .preo[data-cat="${cat[0]}"] ul`).appendChild(preoH);
                });
            }else{
                if(this.diag.querySelector(`.content-resultat-diag .content-recap .preo[data-cat="${cat[0]}"]`) != null){
                    this.diag.querySelector(`.content-resultat-diag .content-recap .preo[data-cat="${cat[0]}"]`).classList.add("off");
                }
            }
        });

        document.querySelectorAll(".content-resultat-diag .products .add-to-cart").forEach(add => {
            cart.buildEventCartAfterDOM(add);
        }); 

        if(document.querySelector(".content-resultat-diag").classList.contains("scrollable")){
            this.buildScrollbar(document.querySelector(".content-resultat-diag"));
        } 

        let url = window.location.origin + window.location.pathname;
        history.replaceState(null, '', url); 
    }

    buildProducts(produits, target){
        let prdCount = 0;
        let prdsHTML = "";
        produits.forEach(prd => {  
            
            console.log(prd);  
            if(typeof this.options.catalog[prd] != "undefined"){ 
                trackPR.push({
                    'event':'diagnostic_result',
                    'event_category': 'Diagnostic',
                    'event_label': this.options.catalog[prd].title,
                    'value': 1
                }); 
                if(this.options.catalog[prd].available){
                    if(this.options.catalog[prd].price < this.options.catalog[prd].compare_at_price){
                        var price = `<div class="price"><span class="oldprice">${this.options.catalog[prd].old_price}</span><span class="currentprice">${this.options.catalog[prd].current_price}</span></div>`;
                    }else{
                        var price = `<div class="price"> 
                            <span class="currentprice">
                                ${catalog[prd].current_price}
                            </span>
                        </div>`;
                    }
                    var atc = `<div class="add-to-cart" data-vid="${this.options.catalog[prd].vid}" data-price="${this.options.catalog[prd].price}"> 
                        <div class="infos">
                            <div class="label">
                                Ajouter
                            </div>
                            <div class="content-loader">
                                <div class="loader">
                                    <div class="mid"></div>
                                </div>
                            </div> 
                        </div> 
                        ${price}
                    </div>`;
                }else{
                    var atc = `<div class="out-of-stock"> 
                        <div class="infos">
                            <div class="label">
                                Rupture de stock
                            </div>
                        </div>
                    </div>`; 
                }

                let title = this.options.catalog[prd].title.split(" - ");
                
                let product = ` 
                    <div class="product-min product-${this.options.catalog[prd].id}">
                        <div class="content-main"> 
                            <a href="${this.options.catalog[prd].url}" class="content-img-prd"> 
                                <img  
                                    src="${this.options.catalog[prd].img0.full}" 
                                    data-full="${this.options.catalog[prd].img0.full}" 
                                />  
                                <img  
                                    src="${this.options.catalog[prd].img1.full}" 
                                    data-full="${this.options.catalog[prd].img1.full}"
                                    class="hover" 
                                />   
                            </a>
                            <div class="content-infos-prd"> 
                                <h3>
                                    ${title[0]} 
                                    <span>${title[1]}</span>  
                                </h3>   
                            </div>  
                            <div class="desc-plus">
                                ${this.options.catalog[prd].description_plus}
                            </div>
                            <div class="content-add-to-cart"> 
                                ${atc}
                            </div> 
                        </div> 
                    </div>   
                `; 

                prdsHTML += product; 
                prdCount++;
            } 
            

        });
        target.innerHTML = prdsHTML; 
        if(prdCount == 0){
            target.closest(".content-products").classList.add("off");
        }
    }

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 

    formatPrice(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (price / 100).toFixed(2) + devise;
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    } 

    async track(email, obj, callBack){  
        var objToString = ""; 
        let params = ""; 
        Object.entries(obj).forEach((field, index) => { 
            objToString += `"${field[0]}" : "${field[1]}"`; 
            if(params == ""){
                params += `?${field[0]}=${field[1]}`;
            }else{
                params += `&${field[0]}=${field[1]}`;
            }  
            if(index < Object.entries(obj).length - 1){
                objToString += ","
            }
        });   

        Object.entries(this.diagData).forEach(cat => {
            if(cat[1].length > 0){  
                params += `&cat_${cat[0]}=${cat[1]}`; 
            }
        });

        Object.entries(this.diagPunchline).forEach(cat => { 
            if(cat[1].length > 0){   
                params += `&punch_${cat[0]}=${cat[1]}`;
            } 
        });

        console.log(params);

        objToString += `,"link" : "https://saltwurksparfuemerie.com/pages/diagnostic-routine${params}&mode=resultat"`;  

        const options = {
            method: 'POST',
            headers: {
                Accept: 'text/html', 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                data: `{
                    "token": "Und3yH", 
                    "event": "diag", 
                    "customer_properties": {
                        "$email": "${email}",
                        "$consent" : "web"
                    },
                    "properties": {
                        ${objToString}
                    }
                }`
            })
        };

        const trackK = await fetch('https://a.klaviyo.com/api/track', options); 

        if(trackK.ok){
            console.log("tracking klaviyo"); 
        }

        await this.checkKlaviyo(email);

        this.buildResult(obj);

        if(typeof callBack == "function"){
            callBack();
        }
         
    } 

    async checkKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: 'TcjGBX'})
        };
        const call = await fetch("https://wlaud0uwn1.execute-api.eu-west-3.amazonaws.com/Prod/klaviyo/checklist", options);  
        const rep = await call.json();   
        if(rep.rep.data.length == 0){ 
            await this.subKlaviyo(dataEmail); 
        }else{
          let sub = false;
          rep.rep.data.forEach(d => {
            if(d.id == "TcjGBX"){
              sub = true;
            }
          });
          if(!sub){
            await this.subKlaviyo(dataEmail);
          }
        }
    }

    async subKlaviyo(dataEmail){   
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: 'TcjGBX', source: "diag"})
        };
        const call = await fetch("https://wlaud0uwn1.execute-api.eu-west-3.amazonaws.com/Prod/klaviyo/subscribe", options);  
        const rep = await call.json();  
        if(typeof rep.statut != "undefined" && rep.statut == "save"){
            console.log("success"); 
        }  
    }

    get diagSave (){  
        return this.diagData;
    }
};

  